import axios from '../../utils/axios';

export async function previewBulk(csvText) {
    const res = await axios.post('/listings/preview', { csvText });
    return res.data;
}

export async function startBulk(rows) {
    const res = await axios.post('/listings/bulk', { rows });
    return res.data;
}

export async function fetchBulkStatus(jobId) {
    const res = await axios.get(`/listings/bulk/status/${jobId}`);
    return res.data;
}

export async function confirmAllAi(jobId) {
    const res = await axios.post(`/listings/bulk/${jobId}/confirm-all-ai`);
    return res.data;
}
